import { useTranslation } from "react-i18next";

const useFormatMonth = () => {
  const { t } = useTranslation();
  const months = [
    t("January"),
    t("February"),
    t("March"),
    t("April"),
    t("May"),
    t("June"),
    t("July"),
    t("August"),
    t("September"),
    t("October"),
    t("November"),
    t("December"),
  ];

  return (date: Date) => months[date.getMonth()];
};

export default useFormatMonth;
